import { render, staticRenderFns } from "./dailyPost.vue?vue&type=template&id=5237f005"
import script from "./dailyPost.vue?vue&type=script&lang=js"
export * from "./dailyPost.vue?vue&type=script&lang=js"
import style0 from "./dailyPost.vue?vue&type=style&index=0&id=5237f005&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports